export interface UtmData {
    utm_source?: string | null
    utm_medium?: string | null
    utm_campaign?: string | null
    utm_term?: string | null
    utm_content?: string | null
    captured_at?: number | null
    landing_url?: string | null
}

export const UTM_QUERY_PREFIX = 'utm_'

/** Коды свойств заказа Bitrix для отдельных UTM-полей */
export const UTM_ORDER_ATTR_CODES = {
    utm_source: 'UTM_SOURCE',
    utm_medium: 'UTM_MEDIUM',
    utm_campaign: 'UTM_CAMPAIGN',
    utm_term: 'UTM_TERM',
    utm_content: 'UTM_CONTENT',
    landing_url: 'UTM_LANDING_URL',
} as const satisfies Record<keyof Omit<UtmData, 'captured_at'>, string>

export type UtmOrderAttrCode = typeof UTM_ORDER_ATTR_CODES[keyof typeof UTM_ORDER_ATTR_CODES]

export const UTM_ORDER_FIELD_MAX_LENGTH = 255
export const UTM_LANDING_URL_MAX_LENGTH = 2000
